import React, {forwardRef, memo} from 'react';

const ActiveRunIndicatorComp = forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div ref={ref} {...props}>
      <div className="ml-[6px] inline-block h-[6px] w-[6px] align-middle rounded-full bg-wb-success-text" />
    </div>
  );
});

const ActiveRunIndicator = memo(ActiveRunIndicatorComp);

export default ActiveRunIndicator;
